<template>
  <global-alert
    v-if="showHeaderAlert"
    :content="alert.content"
    :type="alert.type"
    :closable="alert.closable"
    :show-default-icon="alert.showDefaultIcon"
    :icon="alert.icon"
  />
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      GlobalAlert: () =>
        import(
          /* webpackChunkName: "header-alert-global" */ 'components/Header/White/GlobalAlert'
        )
    },
    computed: {
      ...mapState('header', ['alert']),
      showHeaderAlert() {
        return this.alert.content !== ''
      }
    }
  }
</script>
